import React, { useEffect, useState } from 'react';
const trackFbEvent = (event: string, data?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', event, data);
  }
};
type Plan = 'megapack' | 'megapack-pro';
export function Pricing() {
  useEffect(() => {
    const section = document.getElementById('pricing');
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        trackFbEvent('ViewContent', {
          content_name: 'Pricing Section',
          content_category: 'Megapack Psicología Rentable'
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const [selected, setSelected] = useState<Plan>('megapack-pro');
  const cartUrls: Record<Plan, string> = {
    megapack: 'https://checkout.construyeprogreso.com/cart/48231331791018:1',
    'megapack-pro': 'https://checkout.construyeprogreso.com/cart/48231332380842:1'
  };
  const plans = {
    megapack: {
      emoji: '🧠',
      name: 'MEGAPACK PSICOLOGÍA RENTABLE',
      desc: '6 tomos + 6 bonos · Sistema clínico completo',
      priceOld: '$58.990',
      priceNew: '$19.990',
      priceColor: 'text-gray-900',
      cta: '→ SÍ, QUIERO EL MEGAPACK',
      sub: '6 tomos · 6 bonos · Acceso inmediato'
    },
    'megapack-pro': {
      emoji: '🏆',
      name: 'MEGAPACK + AUTORIDAD CLÍNICA',
      desc: 'Todo el Megapack + posicionamiento, honorarios y soberanía profesional.',
      priceOld: '$102.990',
      priceNew: '$27.990',
      priceColor: 'text-violet-700',
      cta: '→ SÍ, QUIERO EL MEGAPACK + AUTORIDAD CLÍNICA',
      sub: '6 tomos · 6 bonos · Autoridad Clínica™ · Acceso inmediato'
    }
  };
  const active = plans[selected];
  return <section id="pricing" className="w-full px-4 py-12 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(245,243,255) 0%, rgb(245,243,255) 15%, rgb(248,250,252) 85%, rgb(245,243,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-198">
      <div className="mx-auto max-w-2xl" data-id="element-199">
        <div className="text-center mb-8" data-id="element-200">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-wide text-violet-700 border border-violet-500/40 bg-violet-500/5 rounded-full px-4 py-1.5 mb-4" data-id="element-201">
            🔥 Precio de lanzamiento — Sube sin previo aviso
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-202">
            Elegí tu <span className="text-violet-700" data-id="element-203">Megapack:</span>
          </h2>
          <p className="text-xs text-gray-500 m-0" data-id="element-204">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        <div className="flex flex-col gap-3 mb-6" data-id="element-205">
          {(Object.keys(plans) as Plan[]).map(plan => {
          const p = plans[plan];
          const isSelected = selected === plan;
          return <button key={plan} onClick={() => setSelected(plan)} className={`w-full text-left rounded-xl p-4 transition-all cursor-pointer ${isSelected ? 'border-2 border-violet-700 shadow-lg' : 'border border-gray-200 shadow-sm'}`} style={{
            backgroundColor: isSelected ? 'rgb(245, 243, 255)' : 'rgb(255,255,255)',
            boxShadow: isSelected ? 'rgba(124, 58, 237, 0.15) 0px 0px 30px 0px' : undefined
          }} data-id="element-206">
                <div className="flex items-center gap-3" data-id="element-207">
                  <div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${isSelected ? 'border-violet-700' : 'border-gray-300'}`} data-id="element-208">
                    {isSelected && <div className="h-2.5 w-2.5 rounded-full bg-violet-700" data-id="element-209" />}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-210">
                    <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-211">
                      <span data-id="element-212">{p.emoji}</span>
                      <span className="text-sm font-black text-gray-900" data-id="element-213">
                        {p.name}
                      </span>
                      {plan === 'megapack-pro' && <span className="bg-violet-700 text-[10px] font-black text-white rounded-full px-2 py-0.5" data-id="element-214">
                          ⭐ MÁS ELEGIDO
                        </span>}
                    </div>
                    <p className="text-xs text-gray-500 m-0" data-id="element-215">{p.desc}</p>
                  </div>

                  <div className="shrink-0 text-right" data-id="element-216">
                    <div className="text-xs text-gray-400 line-through" data-id="element-217">
                      {p.priceOld}
                    </div>
                    <div className={`text-2xl font-black ${p.priceColor}`} data-id="element-218">
                      {p.priceNew}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        <div className="rounded-2xl p-5 shadow-lg" style={{
        background: 'linear-gradient(135deg, rgb(109, 40, 217), rgb(124, 58, 237))'
      }} data-id="element-219">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mb-4" data-id="element-220">
            {active.sub.split(' · ').map(item => <span key={item} className="text-[11px] font-bold text-white/90 flex items-center gap-1" data-id="element-221">
                <span className="text-white/60" data-id="element-222">✓</span> {item}
              </span>)}
          </div>

          <a href={cartUrls[selected]} onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: selected === 'megapack-pro' ? 'Megapack + Autoridad Clínica' : 'Megapack Psicología Rentable',
          content_category: 'Psicología Rentable',
          value: selected === 'megapack-pro' ? 27990 : 19990,
          currency: 'ARS'
        })} className="block w-full bg-white text-violet-700 text-center text-sm sm:text-base font-black rounded-xl py-4 no-underline hover:bg-violet-50 transition-colors" data-id="element-223">
            {active.cta}
          </a>

          <p className="text-center text-[11px] text-white/70 mt-3 mb-0" data-id="element-224">
            Más de 500 psicólogos ya trabajan con criterio clínico y cobran lo
            que merecen
          </p>
        </div>

        <div className="mt-4 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500 bg-white rounded-xl px-4 py-3 shadow-sm border border-gray-100" data-id="element-225">
          <span data-id="element-226">🔒 Pago seguro</span>
          <span data-id="element-227">⚡ Acceso en 5 min</span>
          <span data-id="element-228">🛡️ Garantía 7 días</span>
          <span data-id="element-229">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}